import Marquee from "react-fast-marquee";

const ITEMS = [
  "Lead from the root.",
  "Rise from the lineage.",
  "Ancient intuition for a new era.",
];

export const MarqueeStrip = () => {
  return (
    <section
      className="w-full overflow-hidden border-y border-[#C5A059]/10 bg-[#070707] py-14 md:py-20"
      data-testid="marquee-section"
    >
      <Marquee speed={45} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="mx-10 font-serif text-5xl italic tracking-tight text-stroke-bronze md:text-8xl">
              {t}
            </span>
            <span className="text-3xl text-[#3B2A48] md:text-5xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default MarqueeStrip;
